import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { FormsModule, FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { UsuarioService } from '../../../services/usuario.service';
import { appsettings } from '../../../settings/appsettings';

@Component({
  selector: 'app-carga-masiva-institucional',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './carga-masiva-institucional.component.html',
  styleUrl: './carga-masiva-institucional.component.css'
})
export class CargaMasivaInstitucionalComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;

  centro: any = [];
  estado: any = [];
  tipo_formador: any = [];
  rol: any = [];
  gerencias: any = [];
  ambito: any = [];

  validaTipoRol: boolean = false;

  errorMessage: string = '';

  private srvLogin = inject(InicioService);
  private servicios = inject(UsuarioService);
  private fb = inject(FormBuilder)
  private url = appsettings.apiUrl;

  formulario: FormGroup;
  constructor( ){
    this.formulario = this.fb.group({
      //---- datos_institucional ----
      centro: ['', Validators.required],
      estado: ['', Validators.required],
      tipo_formador: [''],
      rol: ['', Validators.required],
      gerencias: ['',Validators.required],
      ambito: ['',Validators.required],
    });
  }

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.seleccionarInstitucional('0').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.centro = rs.data.centro;
        this.estado = rs.data.estado;
        this.tipo_formador = rs.data.tipo_formador;
        this.rol = rs.data.rol;
        this.gerencias = rs.data.gerencias;
        this.ambito = rs.data.ambito;
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  valida(eve: any){
    this.validaTipoRol = eve.value == 11 ? true : false;
    if (eve.value == 11) {
      const datos = this.formulario.get('tipo_formador');
      datos?.setValidators([Validators.required]);
      datos?.updateValueAndValidity(); // Important to re-evaluate validation
    }
    else{
      const datos = this.formulario.get('tipo_formador');
      datos?.setValidators([]);
      datos?.updateValueAndValidity(); // Important to re-evaluate validation
    }
  }

  async descargar_formato(){
     if(!this.formulario.valid){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Debe completar los campos requeridos del formulario (*)";
      this.mdl.alerta();
    }
    else{
      this.validaTipoRol ? '' : this.formulario.get('tipo_formador')?.setValue('');
      Object.assign(this.formulario.value, {'id_institucional': this.user.id_institucional});
      console.log('usuario: ',this.formulario.value)
      let ruta;
      this.mdl.cargando();
      this.servicios.descargarFormatoInstitucional(this.formulario.value).subscribe({
        next: (rs) => {
          window.location.href = `${this.url}${rs.data}.xls`;

          console.log('aaaaaa: ',rs.data)

          this.mdl.cerrar();
          ruta = rs.data;
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        }
      });
      //await this.borrar(ruta);
    }
  }

  borrar(ruta: any){
    this.servicios.borrarArchivo({'ruta': ruta}).subscribe({
      next: (rs) => {
        console.log('ooooooo',rs)
        this.mdl.cerrar();
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
      }
    })
  }


}



